module.exports = __webpack_public_path__ + "img/iocn-1.6bb53f88.png";